module.exports = __webpack_public_path__ + "static/media/budget.d896ddbf.svg";